import { render } from "./AcceptDecline.vue?vue&type=template&id=1c48f990&scoped=true"
import script from "./AcceptDecline.vue?vue&type=script&lang=js"
export * from "./AcceptDecline.vue?vue&type=script&lang=js"

import "./AcceptDecline.vue?vue&type=style&index=0&id=1c48f990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c48f990"]])

export default __exports__